<section class="">
    <div class="breadcrumbs-custom-main bg-image bg-employerlist">
        <div class="container">
            <h3 class="breadcrumbs-custom-title"></h3>
        </div>
    </div>
    <div class="breadcrumbs-custom-aside">
        <div class="container">
            <ul *ngIf="title" class="breadcrumbs-custom-path">
                <li><a routerLink="/home">Αρχική</a></li>
                <li class="titleJob" *ngIf="title.length<=30" (click)="jobDetails()"> <a> {{title}}</a></li>
                <li class="titleJob" *ngIf="title.length>30" (click)="jobDetails()"> <a class="title2" placement="top-left" ngbTooltip={{title}}>{{title.substr(0, 30)}}...</a></li>
                <li class="active">Αιτήσεις</li>
            </ul>
        </div>
    </div>
</section>

<section>
    <div *ngIf="applications" class="container">
        <form>
            <div class="row">
                <div id="dropDown" class="col-sm-3">
                    <select (change)="onChange($event)" placeholder="test" style="width: 100%;" class="custom-select">
                        <option value="desc" selected>Πιο πρόσφατες πρώτα</option>
                        <option value="asc">Παλαιότερες πρώτα</option>
                    </select>
                    <p style="padding-left: 10px;" *ngIf="applications.totalElements>0"> Βρέθηκαν {{applications.totalElements}} αιτήσεις
                    </p>
                    <p *ngIf="applications.totalElements==0"> Δεν βρέθηκαν αιτήσεις</p>

                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 col-md-9 col-xl-8">
                    <div class="table-responsive">

                        <table id="table" class="table-responsive table-striped">
                            <tr class="rows" ngDefaultControl [attr.data-item-value]="content.candidateJobPostInfo.cvId" *ngFor="let content of content">
                                <td (click)="candidateProfile(content.candidateJobPostInfo.candidateUuid)" class="jobRow">
                                    <span *ngIf="content.name.length<=20" style="cursor: pointer;"><span style="color:rgb(26, 24, 24)">Όνομα:</span> {{content.name}}</span>
                                    <span *ngIf="content.name.length>20" style="cursor: pointer;" placement="top-left" ngbTooltip={{content.name}}><span style="color:rgb(26, 24, 24)">Όνομα:</span> {{content.name.substr(0, 20)}}...</span>
                                    <br/>
                                    <span *ngIf="content.lastName.length<=20" style="cursor: pointer;"><span style="color:rgb(26, 24, 24)">Επώνυμο:</span> {{content.lastName}}</span>
                                    <span *ngIf="content.lastName.length>20" style="cursor: pointer;" placement="top-left" ngbTooltip={{content.lastName}}><span style="color:rgb(26, 24, 24)">Επώνυμο:</span> {{content.lastName.substr(0, 20)}}...</span>
                                </td>
                                <td class="jobRow">
                                    <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fas fa-envelope" placement="top-left" ngbTooltip="email υποψηφίου" style="background: #ca5217; font-size: 14px;" href="mailto:{{content.email}}"></a>
                                </td>
                                <td class="jobRow">
                                    <span><span> <span style="color:rgb(26, 24, 24)">Ημ/νία Αίτησης:</span> {{content.candidateJobPostInfo.creationDate|date: 'mediumDate'}}</span>
                                    </span>
                                </td>
                                <td class="jobRow">
                                    <button style="font-size: 12px;" class="button button-block button-primary" (click)="openModal(content)">Η
                                        Αιτηση</button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </form>
    </div>
</section>


<!-- modal for the application -->

<div class="modal fade" id="applyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <form>
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div *ngIf="currentApplication" class="modal-content" id="modalContent">
                <div id="modalHeader" class="modal-header">
                    <h5 class="modal-title" id="modalTitle">Αίτηση</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">x</span>
                    </button>
                </div>
                <div class="modal-body modalBody">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row">

                                    <!-- name -->
                                    <div class="col-md-12">
                                        <div class="form-wrap">
                                            <label class="form-label-outside">Όνομα</label>
                                            <div *ngIf="currentApplication" class="form-wrap-inner">
                                                <input [value]="currentApplication.name" class="form-input disabledInput modalNames" type="text" disabled="true">
                                                <!-- <input type="hidden" ngModel name="firstName" [(ngModel)]="firstName"> -->
                                            </div>
                                        </div>
                                    </div>

                                    <!-- surname -->
                                    <div class="col-md-12">
                                        <div class="form-wrap">
                                            <label class="form-label-outside">Επώνυμο</label>
                                            <div *ngIf="currentApplication" class="form-wrap-inner">
                                                <input [value]="currentApplication.lastName" placeholder="" class="form-input disabledInput modalNames" type="text" disabled="true">
                                                <!-- <input type="hidden" ngModel name="lastName" [(ngModel)]="lastName" /> -->
                                            </div>
                                        </div>
                                    </div>

                                    <!-- email -->
                                    <div class="col-md-12">
                                        <div class="form-wrap">
                                            <label class="form-label-outside">Ηλεκτρονικό
                                                Ταχυδρομείο</label>
                                            <div *ngIf="currentApplication" class="form-wrap-inner">
                                                <input disabled="true" [value]="currentApplication.email" class="form-input modalNames" id="rd-navbar-register-email" type="email" />
                                                <!-- <input id="email" type="hidden" [(ngModel)]="email" name="email" /> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- cover letter -->
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div *ngIf="currentApplication" class="form-wrap">
                                            <label class="form-label-outside" for="general-information-name">Cover
                                                Letter</label>
                                            <div class="form-wrap-inner">
                                                <textarea disabled="true" [value]="currentApplication.candidateJobPostInfo.coverLetter" id="textArea" class="form-input mytextArea modalNames" id="general-information-name" type="text" name="description"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- buttons for cv -->
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-md-12">
                        <div class="form-wrap">
                            <label class="form-label-outside">Το Βιογραφικό μου</label>

                            <div class="form-wrap-inner">
                                <div *ngIf="currentApplication" class="group group-xl group-middle">
                                    <a style="font-size: 10px;" class="button button-lg button-primary-cv" (click)="downloadCV(currentApplication)" [href]="fileUrl">
                                        <i class="fa fa-download"></i> {{currentApplication.candidateJobPostInfo.cvId}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>